





import {
  defineComponent, reactive, ref, computed,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import mapData from '@highcharts/map-collection/countries/th/th-all.geo.json';

import province from '@/province.ts';
import getLearningCenterInProvinces from '@/gql/getLearningCenterInProvinces.gql';

const Map = defineComponent({
  setup() {
    const { result } = useQuery(getLearningCenterInProvinces);
    const totalLearningCenter = useResult(result, {}, (data) => data.learningCenters.paginatorInfo.total);
    const thailandProvinces = useResult(result, [{ learningCenters: [] }], (data) => data.thailandProvinces);
    const computedData = computed(() => {
      if (!thailandProvinces) return [[]];
      const _value = thailandProvinces.value?.map((elm: any) => [`th-${province.shortenFormat(elm.name)}`, elm.learningCenters.length]);
      return _value;
    });
    // const provincesList = ref(mapData.features.map((item: any) => item.id));
    const chartOptions = computed(() => ({
      chart: {
        map: mapData,
      },
      title: {
        text: 'แผนที่แสดงจำนวนแหล่งเรียนรู้ในแต่ละจังหวัด',
      },
      subtitle: {
        text: `จำนวนแหล่งเรียนรู้ในประเทศไทย ${typeof totalLearningCenter.value !== 'object' ? totalLearningCenter.value : 0} แห่ง`,
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          alignTo: 'spacingBox',
        },
      },
      colorAxis: {
        min: 1,
        minColor: '#EEEEFF',
        maxColor: '#F65E5C',
      },
      series: [{
        name: 'จำนวนแหล่งเรียนรู้',
        states: {
          hover: {
            color: '#F65E5C',
          },
        },
        dataLabels: {
          enabled: true,
          format: '{point.name}',
        },
        allAreas: false,
        data: computedData.value || [
          ['th-ct', 0], // จันทบุรี
          ['th-4255', 100], //
          ['th-pg', 0], // พังงา
          ['th-st', 0], // สุราษฎร์ธานี
          ['th-kr', 0], // กระบี่
          ['th-sa', 0], // สตูล
          ['th-tg', 0], // ตรัง
          ['th-tt', 0], // ตราด
          ['th-pl', 0], // พัทลุง
          ['th-ps', 0], // พิษณุุโลก
          ['th-kp', 0], // กำแพงเพชร
          ['th-pc', 0], // พิจิตร
          ['th-sh', 0], // สุพรรณบุรี
          ['th-at', 0], // อ่างทอง
          ['th-lb', 0], // ลพบุรี
          ['th-pa', 0], // อยุธยา
          ['th-np', 0], // นครปฐม
          ['th-sb', 0], // สิงห์บุรี
          ['th-cn', 0], // ชัยนาถ
          ['th-bm', 0], // กรุงเทพ
          ['th-pt', 0], // ปทุมธานี
          ['th-no', 0], // นนทบุรี
          ['th-sp', 0], // สมุทรปราการ
          ['th-ss', 0], // สมุทราสาคร
          ['th-sm', 0], // สมุทรสงคราม
          ['th-pe', 0], // เพชรบุรี
          ['th-cc', 0], // ฉะเชิงเทรา
          ['th-nn', 0], // นครนายก
          ['th-cb', 0], // ชลบุรี
          ['th-br', 0], // บุรีย์รัม
          ['th-kk', 0], // ขอนแก่น
          ['th-ph', 0], // เพชรบูรณ์
          ['th-kl', 0], // กาฬสิน
          ['th-sr', 0], // สระบุรี
          ['th-nr', 0], // นครราชศรีมา
          ['th-si', 0], // ศรีสะเกศ
          ['th-re', 0], // ร้อยเอ็ด
          ['th-le', 0], // เลย
          ['th-nk', 0], // หนองคาย
          ['th-ac', 0], // อำนาจเจริญ
          ['th-md', 0], // มุกดาหาร
          ['th-sn', 0], // สกลนคร
          ['th-nw', 0], // นราธิวาส
          ['th-pi', 0], // ปัตตานี
          ['th-rn', 0], // ระนอง
          ['th-nt', 0], // นครศรีธรรมราช
          ['th-sg', 0], // สงขลา
          ['th-pr', 0], // แพร่
          ['th-py', 0], // พะเยา
          ['th-so', 0], // สุโขทัย
          ['th-ud', 0], // อุตรดิตถ์
          ['th-kn', 0], // กาญจนบุรี
          ['th-tk', 0], // ตาก
          ['th-ut', 0], // อุทัยธานี
          ['th-ns', 0], // นครสวรรค์
          ['th-pk', 0], // ประจวบคีรีขันธ์
          ['th-ur', 0], // อุบลราชธานี
          ['th-sk', 0], // สระแก้ว
          ['th-ry', 0], // ระยอง
          ['th-cy', 0], // ชัยภูมิ
          ['th-su', 0], // สุรินทร์
          ['th-nf', 0], // นครพนม
          ['th-bk', 0], // บึงกาฬ
          ['th-mh', 0], // แม่ฮ่องสอน
          ['th-pu', 0], // ภูเก็ต
          ['th-cp', 0], // ชุมพร
          ['th-yl', 0], // ยะลา
          ['th-cr', 0], // เชียงราย
          ['th-cm', 0], // เชียงใหม่
          ['th-ln', 0], // ลำพูน
          ['th-na', 0], // น่าน
          ['th-lg', 0], // ลำปาง
          ['th-pb', 0], // ราชบุรี
          ['th-rt', 0], // ปราจีนบุรี
          ['th-ys', 0], // ยโสธร
          ['th-ms', 0], // มหาสารคาม
          ['th-un', 0], // อุดรธานี
          ['th-nb', 0], // หนองบัวลําภู
        ],
      }],
    }));

    return {
      chartOptions,
      computedData,
    };
  },
  props: {
    maxWidth: {
      type: String,
      default() { return 500; },
    },
  },
});

export default Map;
